import React, { Fragment } from "react";

const TwoParticipants = ({ discussions }) => {
  return (
    <Fragment>
      {discussions && discussions.length % 2 === 0 ? (
        discussions
          .reduce(function (accumulator, currentValue, currentIndex, array) {
            if (currentIndex % 2 === 0)
              accumulator.push(array.slice(currentIndex, currentIndex + 2));
            return accumulator;
          }, [])
          .map((participant) => {
            return (
              <div className="duo-grid">
                <div className="participant">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${participant[0].avatar}`}
                    className="participant-avi"
                    alt="avi-one"
                  />
                  <div>
                    <p className="user-online-item">
                      <span className="green name-font">
                        {participant[0].channelid}
                      </span>
                    </p>
                    <p className="participant-name">
                      {participant[0].firstname} {participant[0].lastname}
                    </p>
                  </div>
                </div>
                <div className="participant">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${participant[1].avatar}`}
                    className="participant-avi"
                    alt="avi-two"
                  />
                  <div>
                    <p className="user-online-item">
                      <span className="green name-font">
                        {participant[1].channelid}
                      </span>
                    </p>
                    <p className="participant-name">
                      {participant[1].firstname} {participant[1].lastname}
                    </p>
                  </div>
                </div>
              </div>
            );
          })
      ) : (
        <div className="duo-grid">
          {discussions &&
            discussions.map((participant) => {
              return (
                <div className="participant">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${participant.avatar}`}
                    className="participant-avi"
                    alt="avi-three"
                  />
                  <div>
                    <p className="user-online-item">
                      <span className="green name-font">
                        {participant.channelid}
                      </span>
                    </p>
                    <p className="participant-name">
                      {participant.firstname} {participant.lastname}
                    </p>
                  </div>
                </div>
              );
            })}
          <div className="participant">
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/innovator.png`}
              className="participant-avi"
              alt="avi-four"
            />
            <p className="participant-name-alt">Awaiting Participant...</p>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default TwoParticipants;
